import { RedocStandalone } from 'redoc';

export default function Swagger() {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            scrollPadding: "0 !important",
            scrollBehavior: "unset !important",
            overflowY: "scroll"
        }}>
            <RedocStandalone specUrl={process.env.REACT_APP_SWAGGER}/>
        </div>
    )
}